import React from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import { Hidden, Visible } from 'react-grid-system';
import {
  Container, Col, Row,
} from '../../components/grid';
import {
  Heading1,
  Span,
  Paragraph,
  Heading2,
  Heading3,
  Heading4,
  Spacer,
  LinkStyled,
  Bold,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { ScreenSizeDetector } from '../../lib/helpers';
import { Image, ImagePopup } from '../../components/Image';
import {
  Table, Td, Th, Tr,
} from '../../components/tables';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Anlaeg" activeSidemenu="OpsaetningAfFadoelsanlaeg">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Opsætning af fadølsanlæg</Heading1>
          <Paragraph>
            Korrekt opsætning af fadølsanlæg er yderst vigtig, da det sikrer dig den bedste oplevelse, smag og brug. Nedenfor finder du en guide til fadølsanlæg opsætning, så du let kan komme godt i gang og servere perfekt tappede fadøl til dine gæster.
            Hos Skafte kan du let <LinkStyled to="/fadoelsanlaeg">leje fadølsanlæg</LinkStyled> til din næste fest, arrangement eller event.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Opsætning af fadølsanlæg</Heading2>
          <Paragraph>
            Anlægget placeres normalt på gulvet og aftapningshanen sættes fast på en bordkant eller lignende på samme måde som f.eks. en arkitektlampe. I forbindelse med opsætning af fadølsanlæg, er det vigtigt, at der under anlægget placeres en tyk avis, måtte eller lignende for at skåne gulvet, idet vi fralægger os ethvert ansvar for mærker, rustpletter, fugt o.lign.
          </Paragraph>
          <Paragraph>
            Det er lettest at placere anlægget først, sammen med øllet og kulsyren. Derved undgår du at skulle bukke dig ind under baren, når du skal sætte anlægget til. Sæt kulsyren bagerst, så den står ind mod baren, når denne sættes op.
          </Paragraph>
          <Paragraph>
            Ved fadølsanlæg opsætning er det er klart bedst, at bruge en forlængerledning med ét stik, hvis du kun har ét fadølsanlæg. Sådan undgår du for meget belastning, så sikringerne springer. Desuden falder stikket ikke så nemt ud, hvis man gør det mest fornuftige; nemlig at slå knude på ledningen.
          </Paragraph>
          <Paragraph>
            Hvis du bruger en tromle som vist i videoen, så er det vigtigt, at rulle tromlen helt ud. På denne måde undgår du, at sikringen i midten af tromlen slår fra, hvis den bliver for varm. Sker dette, så holder anlægget op med at køle og øllet begynder at skumme - og det opdager man ikke lige med det samme, men når det først er sket, så er det allerede for sent. Når strømmen slås til igen, går der et stykke tid før anlægget virker som det skal. Så husk derfor altid at rulle ledningen helt ud i forbindelse med opsætning af fadølsanlæg.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <ScrollableAnchor id="opsaetning-af-fadoelsanlaeg">
        <div>
          <Row>
            <Col xs={12} padding="0">
              <TheVideoPlayer
                url="fbAsc4Z5AfI"
                thumbnail="opsaetning-fadoelsanlaeg-komplet"
                chapters={[
                {
                  time: '00:00',
                  description: '00:00 - Opstilling af udstyr og tilslutning af strøm',
                },
                {
                  time: '01:19',
                  description: '01:19 - Tilslutning af fadøl og kulsyre til fadølsanlæg',
                },
                {
                  time: '03:11',
                  description: '03:11 - Sådan virker vandkølede fadølsanlæg',
                },
                {
                  time: '06:06',
                  description: '06:06 - Opsætning af fadølsbar og tappetårn',
                },
                {
                  time: '07:13',
                  description: '07:13 - Forberedelse før tapning af fadøl',
                },
                {
                  time: '08:36',
                  description: '08:36 - Sådan tapper du en perfekt fadøl',
                },
              ]}
              />
            </Col>
          </Row>
        </div>
      </ScrollableAnchor>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Opsætning af fadølsanlæg: bar og tappetårn</Heading2>
          <Paragraph>
            Sæt baren op omkring anlægget, og læg derefter pladen på. Husk, at have kulsyreflasken mod baren.
          </Paragraph>
          <Paragraph>
            Hvis gæsterne betjenes af en bartender, sættes fadølstårnet på indersiden af baren. Skru tårnet fast med fingrene. Du behøver intet værktøj. Sæt derefter spildbakke og topskilt på.
          </Paragraph>
          <Paragraph>
            Hvis gæsterne selv tapper, hænges tappetårnet ud over barkanten før toppladen lægges på. Bemærk, at overlæggeren er sænket, så der er plads til slangen. Skru tårnet fast med fingrene og sæt derefter spildbakke samt topskilt på plads.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} md={3} textCenter>
          <ImagePopup maxHeight="200px" imageHeight="200px" name="fadoel.bordkantsojle-med-maal.jpg" />
          <Paragraph fontSize="12px">Bordkantsøjle<br />Tryk på billedet for at forstørre</Paragraph>
        </Col>
        <Col xs={12} md={9}>
          <Heading2>Fadølsanlæg opsætning: bordkantsøjle</Heading2>
          <Paragraph>
            Billedet til venstre viser montering af tappetårnet på en almindelig bordkant.
            Den maximale bordtykkelse er ca. 60 mm Tårnet stikker ca. 35mm ind over bordkanten.
            En evt. runding af bordkanten må være afsluttet ca. 10 mm fra den yderste kant.
            Fra bunden af bordet skal der være ca. 125 mm.
            For at undgå trykmærker i bordet anbefales det at lægge papir imellem bord og tappetårn, samt kun at spænde tårnet forsigtigt fast.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} md={3} textCenter>
          <Image name="packs.klapbar-bagside-1hane-1.png" alt="Carlsberg klapbar med fadøl, køleanlæg, kulsyre og tappehane" maxHeight="321px" imageHeight="321px" />
        </Col>
        <Col xs={12} md={9}>
          <Heading3>Mål og vægt</Heading3>
          <Hidden xs>
            <Table lines2>
              <tr>
                <Th>Artikel</Th>
                <Th textRight>H</Th>
                <Th textRight>B</Th>
                <Th textRight>L</Th>
                <Th textRight>D</Th>
                <Th textRight>Vægt (kg)</Th>
              </tr>
              <tr>
                <Td>
                  <ScreenSizeDetector hide={[[575, true], false]} inlineBlock={[[575, false], true]}>
                    <Span>Fadølsanlæg</Span>
                  </ScreenSizeDetector>
                  <ScreenSizeDetector hide={[[575, false], true]} inlineBlock={[[575, true], false]}>
                    <Span>Anlæg</Span>
                  </ScreenSizeDetector>
                </Td>
                <Td textRight>24,5</Td>
                <Td textRight>40,0</Td>
                <Td textRight>60,0</Td>
                <Td textRight>-</Td>
                <Td textRight>42</Td>
              </tr>
              <tr>
                <Td>
                  <ScreenSizeDetector hide={[[575, true], false]} inlineBlock={[[575, false], true]}>
                    <Span>Kulsyreflaske</Span>
                  </ScreenSizeDetector>
                  <ScreenSizeDetector hide={[[575, false], true]} inlineBlock={[[575, true], false]}>
                    <Span>Kulsyre</Span>
                  </ScreenSizeDetector>
                </Td>
                <Td textRight>70,0</Td>
                <Td textRight>-</Td>
                <Td textRight>-</Td>
                <Td textRight>16,0</Td>
                <Td textRight>Tom: 9 | Fuld: 15</Td>
              </tr>
              <tr>
                <Td>
                  <ScreenSizeDetector hide={[[575, true], false]} inlineBlock={[[575, false], true]}>
                    <Span>Fadølsfustage</Span>
                  </ScreenSizeDetector>
                  <ScreenSizeDetector hide={[[575, false], true]} inlineBlock={[[575, true], false]}>
                    <Span>Fustage</Span>
                  </ScreenSizeDetector>
                </Td>
                <Td textRight>47,5</Td>
                <Td textRight>-</Td>
                <Td textRight>-</Td>
                <Td textRight>32,0</Td>
                <Td textRight>Tom: 8-12 | Fuld: 33-37</Td>
              </tr>
              <tr>
                <Td>
                  <ScreenSizeDetector hide={[[575, true], false]} inlineBlock={[[575, false], true]}>
                    <Span>Bar (sat op)</Span>
                  </ScreenSizeDetector>
                  <ScreenSizeDetector hide={[[575, false], true]} inlineBlock={[[575, true], false]}>
                    <Span>Bar</Span>
                  </ScreenSizeDetector>
                </Td>
                <Td textRight>103,0</Td>
                <Td textRight>63,0</Td>
                <Td textRight>123,0</Td>
                <Td textRight>-</Td>
                <Td textRight>-</Td>
              </tr>
              <tr>
                <Td>
                  <ScreenSizeDetector hide={[[575, true], false]} inlineBlock={[[575, false], true]}>
                    <Span>Fadølshane</Span>
                  </ScreenSizeDetector>
                  <ScreenSizeDetector hide={[[575, false], true]} inlineBlock={[[575, true], false]}>
                    <Span>Hane</Span>
                  </ScreenSizeDetector>
                </Td>
                <Td textRight>50,0</Td>
                <Td textRight>21,0</Td>
                <Td textRight>-</Td>
                <Td textRight>7,5</Td>
                <Td textRight>-</Td>
              </tr>
            </Table>
          </Hidden>
          <Visible xs>
            <Paragraph>
              Fadølsanlæg:<br /><Span>H:24,5</Span> | <Span>B:40,0</Span> | <Span>L:60,0</Span> | <Span>Vægt: 42 kg</Span>
            </Paragraph>
            <Paragraph>
              Kulsyreflaske:<br /><Span>H:70,0</Span> | <Span>Ø:16,0</Span> | <Span>Vægt: Tom: 9kg</Span> | <Span>Fuld: 15kg</Span>
            </Paragraph>
            <Paragraph>
              Fadølsfustage:<br /><Span>H:47,5</Span> | <Span>Ø:32,0</Span> | <Span>Vægt:</Span> <Span>Tom: 8-12kg</Span> | <Span>Fuld: 33-37kg</Span>
            </Paragraph>
            <Paragraph>
              Bar (sat op):<br /><Span>H:103,0</Span> | <Span>B:63,0</Span> | <Span>L:123,0</Span>
            </Paragraph>
            <Paragraph>
              Fadølshane:<br /><Span>H:50,0</Span> | <Span>B:21,0</Span> | <Span>Ø:7,5</Span>
            </Paragraph>
          </Visible>
          <Paragraph fontSize="12px">Alle mål i cm. H = Højde, B = Bredde, L = Længde, D = Diameter, T = Tom, F = Fuld</Paragraph>
          <Paragraph fontSize="12px">Fadølsanlægget har et strømforbrug på 300 watt</Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Mål, vægt, kølekapacitet og strømforbrug på udvalgt tappeudstyr</Heading2>
          <Heading4>
            Forudsætninger:
          </Heading4>
          <Paragraph>
            Normalt nedkølingsbehov 25-8: <Bold>17 C&deg;</Bold><br />
            Vands varmekapacitet: <Bold>4,18 KJ/(Kg*K)</Bold><br />
            Isens smeltevarme: <Bold>334 KJ/Kg</Bold><br />
            Virkninggrad kølemaskine max 3,4: <Bold>2,5 faktor</Bold><br />
            Indhold pr. fustage: <Bold>25 l</Bold>
          </Paragraph>
          <Spacer size="30px" />
          <Hidden xs>
            <Table lines2>
              <Tr>
                <Th>Alle kølere målt uden udstyr</Th>
                <Th textRight>&nbsp;</Th>
                <Th textRight>Eventkøler</Th>
                <Th textRight>Minitrope</Th>
                <Th textRight>Tropekøler</Th>
              </Tr>
              <Tr>
                <Td>Brede</Td>
                <Td textRight>cm</Td>
                <Td textRight>40</Td>
                <Td textRight>37</Td>
                <Td textRight>48</Td>
              </Tr>
              <Tr>
                <Td>Længde</Td>
                <Td textRight>cm</Td>
                <Td textRight>50</Td>
                <Td textRight>37</Td>
                <Td textRight>44</Td>
              </Tr>
              <Tr>
                <Td>Højde</Td>
                <Td textRight>cm</Td>
                <Td textRight>30</Td>
                <Td textRight>68</Td>
                <Td textRight>84</Td>
              </Tr>
              <Tr>
                <Td>Rumfang køleanlæg</Td>
                <Td textRight>dm3</Td>
                <Td textRight>60</Td>
                <Td textRight>93</Td>
                <Td textRight>177</Td>
              </Tr>
              <Tr>
                <Td>Vægt uden vand</Td>
                <Td textRight>Kg</Td>
                <Td textRight>32</Td>
                <Td textRight>41</Td>
                <Td textRight>61</Td>
              </Tr>
              <Tr>
                <Td>Vægt fyldt med vand</Td>
                <Td textRight>Kg</Td>
                <Td textRight>42</Td>
                <Td textRight>59</Td>
                <Td textRight>103</Td>
              </Tr>
              <Tr>
                <Td>Vægt med is, vand hældt ud</Td>
                <Td textRight>Kg</Td>
                <Td textRight>37</Td>
                <Td textRight>49</Td>
                <Td textRight>79</Td>
              </Tr>
              <Tr>
                <Td>Isbank</Td>
                <Td textRight>Kg</Td>
                <Td textRight>5</Td>
                <Td textRight>8</Td>
                <Td textRight>18</Td>
              </Tr>
              <Tr>
                <Td>Spids kapacitet ved ind 25C ud 8C</Td>
                <Td textRight>l øl</Td>
                <Td textRight>24</Td>
                <Td textRight>38</Td>
                <Td textRight>85</Td>
              </Tr>
              <Tr>
                <Td>Strømforbrug</Td>
                <Td textRight>W</Td>
                <Td textRight>250-270</Td>
                <Td textRight>450-470</Td>
                <Td textRight>800-840</Td>
              </Tr>
              <Tr>
                <Td>Heraf forbrug omrører</Td>
                <Td textRight>W</Td>
                <Td textRight>20</Td>
                <Td textRight>70</Td>
                <Td textRight>140</Td>
              </Tr>
              <Tr>
                <Td>Energiforbrug til køling</Td>
                <Td textRight>W</Td>
                <Td textRight>230</Td>
                <Td textRight>400</Td>
                <Td textRight>700</Td>
              </Tr>
              <Tr>
                <Td>Kontinuerlig Køle effekt</Td>
                <Td textRight>l øl/time</Td>
                <Td textRight>29</Td>
                <Td textRight>51</Td>
                <Td textRight>89</Td>
              </Tr>
              <Tr>
                <Td>Mindste festlængde i timer ved fustager</Td>
                <Td textRight>5</Td>
                <Td textRight>3,5</Td>
                <Td textRight>1,7</Td>
                <Td textRight>0,5</Td>
              </Tr>
              <Tr>
                <Td>Mindste festlængde i timer ved fustager</Td>
                <Td textRight>10</Td>
                <Td textRight>7,8</Td>
                <Td textRight>4,2</Td>
                <Td textRight>1,9</Td>
              </Tr>
              <Tr>
                <Td>Mindste festlængde i timer ved fustager</Td>
                <Td textRight>15</Td>
                <Td textRight>12,1</Td>
                <Td textRight>6,7</Td>
                <Td textRight>3,3</Td>
              </Tr>
            </Table>
          </Hidden>
          <Visible xs>
            <Paragraph bold>
              Eventkøler
            </Paragraph>
            <Paragraph>
              Bredde: 40 cm<br />
              Længde: 50 cm<br />
              Højde: 30 cm<br />
              Rumfang køleanlæg: 60 dm3<br />
              Vægt uden vand: 32 kg<br />
              Vægt fyldt med vand: 42 kg<br />
              Vægt med is, vand hældt ud: 37 kg<br />
              Isbank: 5 kg<br />
              Spids kapacitet ved ind 25C ud 8C: 24 l øl<br />
              Strømforbrug: 250-270 W<br />
              Heraf forbrug omrører: 20 W<br />
              Energiforbrug til køling: 230 W<br />
              Kontinuerlig Køle effekt: 29 l øl/time<br />
              Mindste festlængde i timer ved fustager: 5: 3,5 timer<br />
              Mindste festlængde i timer ved fustager: 10: 7,8 timer<br />
              Mindste festlængde i timer ved fustager: 15: 12,1 timer
            </Paragraph>
            <Paragraph bold>
              Minitrope
            </Paragraph>
            <Paragraph>
              Bredde: 37 cm<br />
              Længde: 37 cm<br />
              Højde: 68 cm<br />
              Rumfang køleanlæg: 93 dm3<br />
              Vægt uden vand: 41 kg<br />
              Vægt fyldt med vand: 59 kg<br />
              Vægt med is, vand hældt ud: 49 kg<br />
              Isbank: 8 kg<br />
              Spids kapacitet ved ind 25C ud 8C: 38 l øl<br />
              Strømforbrug: 450-470 W<br />
              Heraf forbrug omrører: 70 W<br />
              Energiforbrug til køling: 400 W<br />
              Kontinuerlig Køle effekt: 51 l øl/time<br />
              Mindste festlængde i timer ved fustager: 5: 1,7 timer<br />
              Mindste festlængde i timer ved fustager: 10: 4,2 timer<br />
              Mindste festlængde i timer ved fustager: 15: 6,7 timer
            </Paragraph>
            <Paragraph bold>
              Tropekøler
            </Paragraph>
            <Paragraph>
              Bredde: 48 cm<br />
              Længde: 44 cm<br />
              Højde: 84 cm<br />
              Rumfang køleanlæg: 177 dm3<br />
              Vægt uden vand: 41 kg<br />
              Vægt fyldt med vand: 61 kg<br />
              Vægt med is, vand hældt ud: 103 kg<br />
              Isbank: 18 kg<br />
              Spids kapacitet ved ind 25C ud 8C: 85 l øl<br />
              Strømforbrug: 800-870 W<br />
              Heraf forbrug omrører: 140 W<br />
              Energiforbrug til køling: 700 W<br />
              Kontinuerlig Køle effekt: 89 l øl/time<br />
              Mindste festlængde i timer ved fustager: 5: 0,5 timer<br />
              Mindste festlængde i timer ved fustager: 10: 1,9 timer<br />
              Mindste festlængde i timer ved fustager: 15: 3,3 timer
            </Paragraph>
          </Visible>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
